import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    paperWidthXl: {
        width: '43rem',
        minWidth: '43rem'
    },
    root: { padding: '1.5rem' },
    cancelButton: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end'
    },
    titleContainer: { padding: '.5rem 1.5rem 0 1.5rem' },
    title: {
        fontSize: '1.5rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#370573',
        fontWeight: 'bold' as const,
        overflowWrap: 'break-word' as const,
        paddingBottom: '12px'
    },
    bodyText: { whiteSpace: 'pre-line' as const },
    scBodyText: {
        whiteSpace: 'pre-line' as const,
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333',
        marginBottom: '0'
    },
    scSendTitle: {
        whiteSpace: 'pre-line' as const,
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333',
        fontWeight: 'bold' as const,
        fontSize: '13px',
        marginBottom: '0'
    },
    scSendBody: {
        whiteSpace: 'pre-line' as const,
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333',
        fontSize: '14px',
        marginBottom: '0'
    },
    scDetailStyle: {
        height: '60px',
        padding: '0 1.5rem 1.5rem 1.5rem'
    },
    bodyElementContainer: { padding: '.5rem 0 1.5rem 0' },
    scSubmit: {
        height: '2.8rem',
        width: '10rem',
        textTransform: 'uppercase' as 'uppercase',
        borderRadius: '26px',
        fontWeight: 'bold' as 'bold',
        margin: '1rem',
        color: theme?.app?.applicationColors.enumColors.white || '#FFF',
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.disabledItemColor || '#C8C8C8' },
        '&:active:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#A9A9A9' }
    },
    scCancel: {
        height: '2.8rem',
        width: '10rem',
        fontWeight: 'bold' as 'bold',
        borderRadius: '26px',
        textTransform: 'uppercase' as 'uppercase',
        margin: '1rem'
    }
}));